module.exports = __webpack_public_path__ + "static/media/LogoSU.971c14cc.png";